(function () {
  function init() {
    // Theme 'smt-loadding' class blijft soms hangen -> forceer weg
    document.documentElement.classList.remove('smt-loadding');

    // Delegation: tap ergens in een .co-field -> focus de input erin
    // Dit omzeilt mobiele theme-overlays die label-clicks stelen
    document.querySelectorAll('.co-field').forEach(function (field) {
      field.addEventListener('click', function (e) {
        // Als de klik al op input/select/textarea is, doe niks
        if (e.target.matches('input, select, textarea')) return;
        var input = field.querySelector('input, select, textarea');
        if (input) {
          e.preventDefault();
          e.stopPropagation();
          input.focus();
          try { input.click(); } catch (err) {}
        }
      }, { capture: true });

      // iOS: touchstart is sneller dan click
      field.addEventListener('touchend', function (e) {
        if (e.target.matches('input, select, textarea, a, button')) return;
        var input = field.querySelector('input, select, textarea');
        if (input && document.activeElement !== input) {
          input.focus();
        }
      }, { passive: true });
    });
    // Na succesvol versturen: scroll naar succes-melding
    var success = document.querySelector('.co-form-success');
    if (success) {
      try { success.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }

    // Smooth scroll naar #bezoek anchor
    document.querySelectorAll('a[href="#bezoek"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById('bezoek');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
